import { render, staticRenderFns } from "./PostbackEdit.vue?vue&type=template&id=02ee01cc&scoped=true"
import script from "./PostbackEdit.vue?vue&type=script&lang=js"
export * from "./PostbackEdit.vue?vue&type=script&lang=js"
import style0 from "./PostbackEdit.vue?vue&type=style&index=0&id=02ee01cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee01cc",
  null
  
)

export default component.exports